import M from 'materialize-css';

import { createElement } from '../support/dom';
import { hasClass } from '../support/classes';
import Component from './Component';

class Collapsible extends Component
{
    constructor(element, props)
    {
        super(element, props);

        this.initialize();
    }

    initialize()
    {
        this.bindEvents();

        M.Collapsible.init(this.element, this.props);

        const subCollapsibles = this.element.getElementsByClassName('.collapsible');

        for (let i = 0; i < subCollapsibles.length; i++)
        {
            M.Collapsible.init(subCollapsibles[i], this.props);
        }
    }

    bindEvents()
    {
        this.element.addEventListener('click', this._handleClick);
    }

    _handleClick = (e) =>
    {
        if (hasClass(e.target, 'collapsible-header'))
        {
            e.preventDefault();
        }
    }
}

export default Collapsible;